import styled from '@emotion/styled';
import { Theme } from '@silvertours/front-shared';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.neutral.grey160};

  a {
    fill: currentcolor;
    color: ${Theme.defaultTheme.colors.brand
      .green100}; /* enforce FLOYT green */
  }
`;

export { LogoWrapper };
